import {Box} from '@mui/material';
import {string} from 'prop-types';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import Checkbox from '../field-components/Checkbox/Checkbox';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';

const CheckboxGroupRenderer = ({control, field, prefix = ''}) => (
  <>
    <FieldLabel required={field.required}>{field.label}</FieldLabel>

    <Box sx={{display: 'flex', gap: 2, ml: 2, mt: 1.5}}>
      {field.options.map(opt => (
        <Checkbox key={opt.name} control={control} name={buildFieldName(opt, prefix)} label={opt.label} />
      ))}
    </Box>
  </>
);

CheckboxGroupRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string
};

export default CheckboxGroupRenderer;
